<template>
  <div class="contai_h">
    <!-- 这是头部信息 -->
    <div class="contai">
      <i class="el-icon-s-home">
        <router-link to="/">首页</router-link>
        <span class="head_text">会员资料管理 </span>
      </i>
      <div class="haed_cont">
        <span>今天是：{{ deta }}</span>
      </div>

      <div class="head_right">
        <span>会员数：{{ len }}</span>
      </div>
    </div>

    <!-- 搜索栏 -->
    <div class="serch_box">
      <div class="serch">
        <el-input placeholder="请输入姓名" v-model="input_ser" clearable class="ser" />
        <el-button type="primary" icon="el-icon-search" @click="serch">搜索</el-button>
      </div>
      <div class="serch">
        <el-input
          placeholder="请输入证件号"
          v-model="inputSerchCard"
          clearable
          class="ser"
        />
        <el-button type="primary" icon="el-icon-search" @click="serchCard"
          >搜索</el-button
        >
      </div>
      <div class="serch">
        <el-input
          placeholder="请输入手机号"
          v-model="inputSerchPhoneNumber"
          clearable
          class="ser"
        />
        <el-button type="primary" icon="el-icon-search" @click="serchPhoneNumber"
          >搜索</el-button
        >
      </div>
      <!-- 按日期查找 -->
      <div class="serchDate">
        <el-date-picker
          v-model="valueDate"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-button type="primary" icon="el-icon-search" @click="serchDate"
          >搜索</el-button
        >
      </div>
      <!-- 客户不良记录 -->
      <div class="adverse_records">
        <el-button type="warning" plain @click="BadReadData">不良存疑记录</el-button>
      </div>
    </div>

    <!-- 这是信息展示栏 -->
    <div class="content">
      <el-table :data="this.items" style="width: 100%" height="880px">
        <el-table-column type="expand">
          <template slot-scope="props">
            <span @click="Updates">修改</span>
            <el-form
              label-position="left"
              inline
              class="demo-table-expand"
              @change="testa"
            >
              <el-form-item label="当户姓名"
                >：

                <span v-if="xgcz">
                  <el-input
                    v-model="props.row.name"
                    class="inpo"
                    @input="input_te(props.row.name)"
                  ></el-input>
                </span>
                <span v-else>{{ props.row.name }}</span>
              </el-form-item>
              <el-form-item label="身份证号"
                >：

                <span v-if="xgcz">
                  <el-input
                    v-model="props.row.idcard"
                    class="inpo"
                    @input="input_t"
                  ></el-input>
                </span>
                <span v-else>{{ props.row.idcard }}</span>
              </el-form-item>
              <el-form-item label="证件地址"
                >：

                <span v-if="xgcz">
                  <el-input
                    v-model="props.row.address"
                    class="inpo"
                    @input="input_tr"
                  ></el-input>
                </span>
                <span v-else>{{ props.row.address }}</span>
              </el-form-item>

              <el-form-item label="联系电话"
                >：

                <span v-if="xgcz">
                  <el-input
                    v-model="props.row.telephone"
                    class="inpo"
                    @input="input_tf"
                  ></el-input>
                </span>
                <span v-else>{{ props.row.telephone }}</span>
              </el-form-item>
              <el-form-item label="收货地址"
                >：

                <span v-if="xgcz">
                  <el-input
                    v-model="props.row.sfdz"
                    class="inpo"
                    @input="input_ts"
                  ></el-input>
                </span>
                <span v-else>{{ props.row.sfdz }}</span>
              </el-form-item>
            </el-form>

            <!-- 操作栏 -->
            <div class="cont">
              <span>操作:</span>
              <el-button type="danger" @click="detai(props.row._id)"
                >删除该用户</el-button
              >
              <el-button type="success" @click="con_tj(props.row._id)"
                >修改用户信息</el-button
              >
              <el-button type="warning" @click="con_jl(props.row.idcard)"
                >典当记录</el-button
              >
              <!-- 查看银行卡信息 -->
              <el-button type="primary" @click="con_bank(props.row._openid)"
                >查看银行卡</el-button
              >
              <!-- 添加不良记录 -->
              <el-button type="info" @click="add_badness(props.row)"
                >查看/添加不良记录</el-button
              >
              <!-- 操作面板 -->
              <!-- <div class="cont_cz" v-if="czl">
                <h3>点击删除数据:</h3>
                <el-button type="success" @click="detai">删除该当户资料</el-button>
              </div> -->
              <!-- 修改当户信息 -->
              <div v-if="xgcz" class="sendUpdate">
                提交修改:
                <el-button type="primary" @click="modify">确定修改</el-button>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="name"> </el-table-column>
        <el-table-column label="身份证号" prop="idcard"> </el-table-column>
        <el-table-column label="证件地址" prop="address"> </el-table-column>
        <el-table-column label="联系电话" prop="telephone"> </el-table-column>
        <el-table-column label="收货地址" prop="sfdz"> </el-table-column>
        <el-table-column label="注册时间" prop="date"> </el-table-column>
      </el-table>

      <div class="pag">
        <el-pagination
          :page-size="100"
          background
          layout="prev, pager, next"
          @current-change="current"
          :total="len"
        >
        </el-pagination>
      </div>

      <el-dialog title="典当记录" :visible.sync="dialogTableVisible" width="80%">
        <el-tabs type="border-card" @tab-click="con_xx">
          <el-tab-pane label="线下典当纪录">
            <el-table
              :data="xxdata"
              border
              style="width: 100%"
              show-summary
              :summary-method="getSummaries"
            >
              <el-table-column prop="deta" label="建当日期" width="180">
              </el-table-column>
              <el-table-column prop="name" label="姓名" width="120"> </el-table-column>
              <el-table-column prop="ticketnumber" label="票号" width="120">
              </el-table-column>
              <el-table-column prop="telnumber" label="电话" width="150">
              </el-table-column>
              <el-table-column prop=" objname" label="物品名称" width="150">
              </el-table-column>
              <el-table-column prop="startdate" label="典当开始日" width="150">
              </el-table-column>
              <el-table-column prop="enddate" label="结束日期" width="150">
              </el-table-column>
              <el-table-column prop="days" label="典当天数" width="150">
              </el-table-column>
              <el-table-column prop="price" label="典当价格" width="150">
              </el-table-column>
              <el-table-column prop="agent" label="经办人" width="150"> </el-table-column>
              <el-table-column prop="review" label="复核人" width="150">
              </el-table-column>
              <el-table-column label="查看详细记录" width="150">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="handleEdit(scope.row.ticketnumber)"
                    >点击查看</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>

          <el-tab-pane label="线上典当记录">
            <el-table :data="ddata" border>
              <el-table-column property="name" label="姓名" width="200"></el-table-column>
              <el-table-column
                property="telephone"
                label="联系电话"
                width="200"
              ></el-table-column>
              <el-table-column
                property="itemlb"
                label="物品类型"
                width="200"
              ></el-table-column>
              <el-table-column
                property="attrsx"
                label="物品属性"
                width="200"
              ></el-table-column>
              <el-table-column
                property="date"
                label="典当日期"
                width="150"
              ></el-table-column>
              <el-table-column
                property="preFinishedDate"
                label="结束日期"
                width="150"
              ></el-table-column>
              <el-table-column
                property="mode"
                label="典当天数"
                width="150"
              ></el-table-column>
              <el-table-column
                property="mod"
                label="鉴定方式"
                width="150"
              ></el-table-column>
              <el-table-column
                property="price"
                label="典当价格"
                width="150"
              ></el-table-column>
              <el-table-column
                property="state"
                label="典当状态"
                width="150"
              ></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>

        <!-- 查看详情内层 -->
        <el-dialog
          width="60%"
          title="典当记录"
          :visible.sync="innerVisible"
          append-to-body
        >
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="stas" label="业务状态" width="80"> </el-table-column>
            <el-table-column prop="ticketnumber" label="票号" width="120">
            </el-table-column>
            <el-table-column prop="name" label="姓名"> </el-table-column>
            <el-table-column prop="itemname" label="物品名称" width="120">
            </el-table-column>
            <el-table-column prop="xuday" label="操作日期" width="120"> </el-table-column>
            <el-table-column prop="overdate" label="开始日期" width="120">
            </el-table-column>
            <el-table-column prop="enddate" label="到期日期" width="120">
            </el-table-column>
            <el-table-column prop="dday" label="天数"> </el-table-column>
            <el-table-column prop="pri" label="典当金额"> </el-table-column>
            <el-table-column prop="xupri" label="典当综合费"> </el-table-column>
            <el-table-column prop="lx" label="典当利息"> </el-table-column>
            <el-table-column prop="ytdy" label="逾期天数"> </el-table-column>
            <el-table-column prop="rece" label="实付金额"> </el-table-column>
            <el-table-column prop="xuname" label="操作人" width="150"> </el-table-column>
          </el-table>
        </el-dialog>
      </el-dialog>

      <el-dialog title="银行卡信息" :visible.sync="dialogTabs" width="60%">
        <div class="banks_row">
          银行卡数：<span class="banks_ro">{{ bankslen }}</span>
        </div>
        <div class="conts_banks" v-if="bankslen != 0">
          <span>开户人：{{ userName }} </span>
          <span>开户行：{{ bankInfo }}</span>
          <span>银行卡号：{{ bankCard }}</span>
          <!-- <span style="margin: 10px auto">
            <el-button type="primary" @click="sendBankCard">提交修改</el-button></span> -->
        </div>
        <div v-else>
          <h3>该当户未添加银行信息</h3>
        </div>
      </el-dialog>
    </div>
    <!-- 添加不良记录弹窗 -->
    <div>
      <el-dialog
        title="历史不良记录"
        :visible.sync="dialog"
        width="40%"
        :before-close="handleClose"
      >
        <div>
          <!-- 添加不良记录和查看不良记录 -->
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="不良典当记录" name="first">
              <el-table :data="badDataTable" style="width: 100%">
                <el-table-column prop="createDate" label="添加日期"> </el-table-column>
                <el-table-column prop="name" label="当户姓名"> </el-table-column>
                <el-table-column prop="idcard" label="证件号码"> </el-table-column>
                <el-table-column prop="content" label="记录详情"> </el-table-column>
                <el-table-column prop="addname" label="添加操作人"> </el-table-column>
              </el-table>
            </el-tab-pane>

            <el-tab-pane label="添加不良典当记录" name="second">
              <span>添加日期：{{ Todaydeta }}</span>
              <div>
                <span
                  >添加内容：
                  <textarea
                    type="textarea"
                    v-model="inputData"
                    style="height: 100px; width: 300px"
                  />
                </span>
              </div>
              <button style="margin: 20px 0" @click="submit">提交</button>
            </el-tab-pane>
          </el-tabs>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">关闭</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 不良记录列表 -->
    <div class="badData">
      <el-dialog
        title="不良记录列表"
        :visible.sync="ReadBadDataShow"
        width="60%"
        :before-close="HandleClose"
      >
        <!-- 内容列表 -->
        <div>
          <el-table :data="BadTableData" style="width: 100%" height="700">
            <el-table-column prop="_id" label="id"> </el-table-column>
            <el-table-column prop="createDate" label="添加日期"> </el-table-column>
            <el-table-column prop="name" label="客户姓名"> </el-table-column>
            <el-table-column prop="idcard" label="证件号码"> </el-table-column>
            <el-table-column prop="content" label="不良记录"> </el-table-column>
            <el-table-column prop="addname" label="添加人"> </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="HandleClose">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "charged",
  data() {
    return {
      deta: "", //今天的日期
      len: 0, //当户资料
      ACCESS_TOKEN: "", //拿到ACCESS_TOKEN
      items: [], //存储请求回来的数据
      id: "", //物品id
      xgcz: false, //默认关闭修改面板
      did: "", //点击要修改的用户id
      name: "", //当户名字
      nameInfo: "", //当前登录的名字
      idcard: "", //身份证号
      address: "", //证件地址
      telephone: "", //联系电话
      sfdz: "", //收货地址
      ddata: [], //典当记录数据
      xxdata: [], //线下典当记录
      idcards: "", //被点击的证件号

      dialogTableVisible: false,
      dialogTabs: false, //银行卡的弹窗默认关闭
      innerVisible: false, //查看详情内层
      banks: [], //当户银行卡信息
      bankslen: 0, //银行卡添加数，如果为0，则表示没有添加，1则表示有一个银行卡信息
      input_ser: "", //搜索栏输入的名字
      inputSerchCard: "", //搜索栏输入的身份证号
      inputSerchPhoneNumber: "", //搜索栏输入的手机号码

      tableData: [], //典当记录数据

      bankCard: "", //银行卡号
      userName: "", //开户名
      bankInfo: "", //开户行
      bankId: "", //银行卡信息id

      dialog: false, //不良记录添加弹窗

      activeName: "first",

      inputData: "", //填写不良记录内容

      Todaydeta: "", //今天的日期

      submitData: {}, //添加谁的数据

      badDataTable: [], //获取到不良记录

      badNumber: 0, //不良记录数量

      valueDate: "",

      ReadBadDataShow: false, // 不良记录列表开关
      BadTableData: [], //不良记录数据
    };
  },
  methods: {
    //修改客户资料
    Updates() {
      this.isUpdate = true;
    },
    testa(e) {
      console.log(e);
    },
    //搜索名字
    serch() {
      if (this.input_ser != "") {
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("user2020zl").where({name:"' +
              this.input_ser +
              '"}).limit(1000).get()',
          })
          .then((serch) => {
            serch.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.items = serch.data.data;
          });
      } else {
        this.$alert("请输入当户姓名在搜索哦", "提示", {
          confirmButtonText: "确定",
        }).then(() => {
          this.$router.go(0);
        });
      }
    },

    //搜索证件号码
    serchCard() {
      //身份证号搜索栏不为空时
      if (this.inputSerchCard != "") {
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("user2020zl").where({idcard:"${this.inputSerchCard}"}).limit(1000).get()`,
          })
          .then((serch) => {
            serch.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.items = serch.data.data;
          });
      } else {
        this.$alert("请输入当户身份证号在搜索哦", "提示", {
          confirmButtonText: "确定",
        }).then(() => {
          this.$router.go(0);
        });
      }
    },
    //搜索栏手机号码
    serchPhoneNumber() {
      //手机搜索栏不为空时
      if (this.inputSerchPhoneNumber != "") {
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("user2020zl").where({telephone:"${this.inputSerchPhoneNumber}"}).limit(1000).get()`,
          })
          .then((serch) => {
            serch.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.items = serch.data.data;
          });
      } else {
        this.$alert("请输入当户手机号在搜索哦", "提示", {
          confirmButtonText: "确定",
        }).then(() => {
          this.$router.go(0);
        });
      }
    },
    //日期查找栏
    serchDate() {
      console.log(this.valueDate);
      if (this.valueDate !== null && this.valueDate !== "") {
        //查找日期区间的数据
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("user2020zl").where({date:_.gte("${this.valueDate[0]}").and(_.lte("${this.valueDate[1]} 23:59:59"))}).limit(1000).get()`,
          })
          .then((serch) => {
            serch.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.items = serch.data.data;
          });
      } else {
        this.$message.error("查找的日期为空，请选择日期在查找");
      }
    },

    detai(e) {
      if (this.nameInfo == "管理员") {
        this.$confirm("此操作将永久删除该客户, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.axios
              .post("/api/tcb/databasedelete?access_token=" + this.ACCESS_TOKEN, {
                env: `${this.userData.env}`,
                query: 'db.collection("user2020zl").doc("' + e + '").remove()',
              })
              .then(() => {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                setTimeout(() => {
                  this.$router.go(0);
                }, 1200);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$alert("对不起，您没有该权限，请联系管理员做此操作", {
          confirmButtonText: "确定",
        });
      }
    },
    //当户名字
    input_te(e) {
      this.name = e;
    },
    //当户身份证号
    input_t(e) {
      this.idcard = e;
    },
    //证件地址
    input_tr(e) {
      console.log("输入框的地址", e);
      this.address = e;
    },
    //联系电话
    input_tf(e) {
      this.telephone = e;
    },
    //收货地址
    input_ts(e) {
      this.sfdz = e;
    },
    con_tj(e) {
      //查找用户信息然后赋值，
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("user2020zl").doc("${e}").get()`,
        })
        .then((re) => {
          re.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          (this.name = re.data.data[0].name),
            (this.idcard = re.data.data[0].idcard),
            (this.address = re.data.data[0].address),
            (this.telephone = re.data.data[0].telephone);
          this.sfdz = re.data.data[0].sfdz;
        });
      // this.$confirm("是否要修改用户的信息", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      //     this.modify(e);
      //   })
      //   .catch(() => {
      //     this.$message({
      //       type: "info",
      //       message: "已取消修改",
      //     });
      //   });
      this.did = e;
      this.xgcz = !this.xgcz;
    },

    //查看当户典当记录
    con_jl(event) {
      this.idcards = event;

      //默认典当记录
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("add_data").where({cardnumber:"' +
            this.idcards +
            '",whether:true}).limit(1000).get()',
        })
        .then((ref) => {
          ref.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.xxdata = ref.data.data;
        });

      this.dialogTableVisible = !this.dialogTableVisible;
    },

    //查看银行卡
    con_bank(e) {
      let openid = e;
      this.dialogTabs = !this.dialogTabs;

      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("userbank").where({_openid:"' +
            openid +
            '"}).limit(1000).get()',
        })
        .then((rcs) => {
          rcs.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          if (rcs.data.data.length != 0) {
            this.bankCard = rcs.data.data[0].userbank;
            this.userName = rcs.data.data[0].username;
            this.bankInfo = rcs.data.data[0].userinfo;
            this.bankId = rcs.data.data[0]._id;
            this.bankslen = rcs.data.data.length;
          }
        });
    },

    //查看线下典当记录
    con_xx(e) {
      if (e.index == 1) {
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("user_ddxx").where({idcard:"' +
              this.idcards +
              '"}).limit(1000).get()',
          })
          .then((rec) => {
            rec.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.ddata = rec.data.data;
          });
      } else if (e.index == 0) {
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("add_data").where({cardnumber:"' +
              this.idcards +
              '",whether:true}).limit(1000).get()',
          })
          .then((ref) => {
            ref.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.xxdata = ref.data.data;
          });
      }
    },

    modify() {
      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("user2020zl").doc("${this.did}").update({data:{name:"${this.name}",idcard:"${this.idcard}",address:"${this.address}",telephone:"${this.telephone}",sfdz:"${this.sfdz}"}})`,
        })
        .then(() => {
          this.$message({
            message: "当户信息修改成功",
            type: "success",
          });
        });
    },

    //处理统计栏
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "业务数量:" + data.length;
          return;
        }

        const values = data.map((item) => Number(item[column.property]));
        if (
          !values.every((value) => isNaN(value)) &&
          index !== 2 &&
          index !== 3 &&
          index !== 4 &&
          index !== 5 &&
          index !== 6 &&
          index !== 7
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += "元";
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },

    //点击查看单笔详细
    handleEdit(e) {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").where({ticketnumber:"${e}"}).get()`,
        })
        .then((rdata) => {
          rdata.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          if (rdata.data.errcode == 0) {
            this.innerVisible = !this.innerVisible;
            this.tableData = rdata.data.data;
          }
        });
    },

    //修改银行卡事件
    sendBankCard() {
      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("userbank").doc("${this.bankId}").update({data:{username:"${this.userName}",userbank:"${this.bankCard}",userinfo:"${this.bankInfo}"}})`,
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.$message({
              message: "银行卡修改成功",
              type: "success",
            });
            setTimeout(() => {
              this.$router.go(0);
            }, 1000);
          }
        });
    },

    //分页点击事件
    current(e) {
      let ae = e - 1;
      let pags = ae * 100;
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("user2020zl").where({}).limit(100).skip(' + pags + ").get()",
        })
        .then((aa) => {
          if (aa.data.errcode == 0) {
            aa.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.items = aa.data.data;
          }
        });
    },

    //添加不良记录
    add_badness(event) {
      this.dialog = true;
      this.submitData = event;

      if (this.activeName == "first") {
        this.getBadData();
      }
    },

    getBadData() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("badData").where({name:"${this.submitData.name}"}).limit(1000).get()`,
        })
        .then(async (res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.badDataTable = res.data.data;
          this.badNumber = res.data.data.length + 1;
        });
    },
    //关闭不良记录
    handleClose() {
      this.dialog = false;
      this.inputData = "";
      (this.submitData = {}), (this.badDataTable = []), (this.badNumber = 0);
    },
    //不良记录弹窗内点击事件
    handleClick(event) {
      if (event.index == 0) {
        this.getBadData();
      }
    },
    submit() {
      //添加数据
      this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("badData").add({data:{createDate:"${this.Todaydeta}",name:"${this.submitData.name}",idcard:"${this.submitData.idcard}",content:"${this.inputData}",addname:"${this.name}"}})`,
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.$notify({
              title: "添加成功",
              message: `当户：${this.submitData.name} 已成功添加一条不良典当记录`,
              type: "success",
            });
            this.send(this.Todaydeta, this.submitData.name, this.inputData);
            setTimeout(() => {
              this.handleClose();
            }, 800);
          } else {
            this.$notify({
              title: "添加失败",
              message: "添加失败，请刷新后再试",
              type: "warning",
            });
          }
        });
    },
    //发送推送
    send(date, name, content) {
      let openid = [
        "ot6pe5cMagF59URlzBimGw0OVm9k",
        "ot6pe5QpRVVtfb_tQPj8XuXpZVMs",
        "ot6pe5UKeXz0gtSlOV1YothNNqQQ",
      ];
      for (let i = 0; i < openid.length; i++) {
        this.axios.post(
          "/api/cgi-bin/message/wxopen/template/uniform_send?access_token=" +
            this.ACCESS_TOKEN,
          {
            touser: openid[i], //ot6pe5cMagF59URlzBimGw0OVm9k  ot6pe5QpRVVtfb_tQPj8XuXpZVMs   ot6pe5UKeXz0gtSlOV1YothNNqQQ
            mp_template_msg: {
              appid: "wx9019ccce538953c5",
              template_id: "a2UyeDFOJopn32ebyFtLPTeDdR8FkECjlXhkLJ47-sc",

              data: {
                first: {
                  value: `经办人：${this.name} ，给客户${name}添加一条典当不良记录`,
                  color: "#173177",
                },
                keyword1: {
                  value: `${name}-第${this.badNumber}次不良记录`,
                  color: "#173177",
                },
                keyword2: {
                  value: `${date}`,
                  color: "#173177",
                },
                keyword3: {
                  value: `当户-${name}`,
                  color: "#173177",
                },

                remark: {
                  value: `${content}`,
                  color: "#173177",
                },
              },
            },
          }
        );
      }
    },
    //获取不良数据
    BadReadData() {
      this.ReadBadDataShow = !this.ReadBadDataShow;
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("badData").where({}).limit(1000).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          console.log(res);
          this.BadTableData = res.data.data;
        });
    },
    //关闭不良数据弹窗
    HandleClose() {
      this.ReadBadDataShow = false;
    },
  },
  created() {
    //拿到今天的日期 星期
    this.deta = dayjs().format("YYYY-MM-DD ddd");
    //
    this.Todaydeta = dayjs().format("YYYY-MM-DD");
    //拿到ACCESS_TOKEN
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN");
    //获取到this.ACCESS_TOKEN
    this.getTokens();

    //获取当前登录的用户数据
    this.getUserToken();
  },
  mounted() {
    setTimeout(() => {
      //请求数据
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: 'db.collection("user2020zl").where({}).limit(100).get()',
        })
        .then((aa) => {
          if (aa.data.errcode == 0) {
            aa.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.len = aa.data.pager.Total;
            this.items = aa.data.data;
          } else {
            this.$notify.error({
              title: "错误提示",
              message: "密钥过期啦，请刷新页面",
            });
          }
        });

      this.nameInfo = this.userData.username;
    }, 800);
  },
};
</script>
<style scoped>
.contai_h {
  margin: 0 0;
}
.contai {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
}
.contai i {
  font-size: 25px;
  margin: 13px 40px;
}
.head_text {
  font-size: 20px;
  margin: 2px 6px;
}
.router-link-active {
  text-decoration: none;
  font-size: 20px;
  margin-left: 10px;
}
.haed_cont {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
  font-size: 20px;
}
.head_right {
  margin: 13px 50px;
  font-size: 20px;
}
.content {
  margin: 10px auto;
}

/* 列表样式 */
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 10px;
  width: 50%;
}
.cont {
  margin: 20px 0;
}
.cont span {
  margin: 0 10px;
}
.inpo {
  width: 80%;
}
.conts_banks {
  display: flex;
  flex-direction: column;
}
.conts_banks span {
  margin: 20px 0;
}
.serch {
  margin: 9px 30px;
  width: 13%;
  display: flex;
  flex-direction: row;
}
.serchDate {
  margin: 9px 30px;
  width: 25%;
  display: flex;
  flex-direction: row;
}
.adverse_records {
  margin: 9px 30px;
}
.serch_box {
  width: 100%;
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
  border-radius: 10px;
  margin-top: 10px;
}
/* span input{
  outline: none;
  border: 0;
  color: #c44257;
  width: 50%;
} */
.pag {
  margin: 10px auto;
  text-align: center;
}
.sendUpdate {
  margin: 30px 0;
}
.banks_row {
  margin: 20px 0;
}
.banks_ro {
  font-weight: bold;
  font-size: 15px;
  color: red;
}
</style>
